import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { OngletlayoutComponent } from '../../../../../components/layouts/ongletlayout/ongletlayout.component';
import { NgIf } from '@angular/common';
import { UiButtonComponent } from '../../../../../components/button/button.component';

@Component({
  selector: 'app-rapport-mensuel',
  imports: [
    RouterOutlet,
    MatIcon,
    OngletlayoutComponent,
    //UiTable,
    NgIf,
    UiButtonComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './rapport-mensuel.component.html',
  styleUrl: './rapport-mensuel.component.css'
})
export class RapportMensuelComponent {

}
